import React from "react";
import { Box, Typography, Paper, Button, alpha, useTheme } from "@mui/material";
import { Receipt, Print, Share } from "@mui/icons-material";

const OfferSummarySection = ({ offerDetails, onPrint, onShare }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        bgcolor: "white",
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <Receipt sx={{ color: theme.palette.primary.main, fontSize: 20 }} />
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 700,
            fontSize: "0.95rem",
            color: theme.palette.text.primary,
          }}
        >
          Offer Price
        </Typography>
      </Box>

      {/* Price Display */}
      <Box
        sx={{
          bgcolor: alpha(theme.palette.error.main, 0.05),
          borderRadius: 2,
          p: 2.5,
          mb: 2,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: "0.7rem",
            textTransform: "uppercase",
            fontWeight: 600,
            letterSpacing: 0.5,
            display: "block",
            mb: 0.5,
          }}
        >
          Offer Price
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            color: theme.palette.error.main,
            fontSize: "2rem",
          }}
        >
          Rs. {parseFloat(offerDetails.price).toFixed(2)}
        </Typography>
      </Box>

      {/* Action Buttons */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Button
          variant="outlined"
          startIcon={<Print />}
          onClick={onPrint}
          fullWidth
          sx={{
            py: 1,
            borderRadius: 1.5,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.9rem",
          }}
        >
          Print Offer
        </Button>
        {/* <Button
          variant="outlined"
          startIcon={<Share />}
          onClick={onShare}
          fullWidth
          sx={{
            py: 1,
            borderRadius: 1.5,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.9rem",
          }}
        >
          Share Offer
        </Button> */}
      </Box>
    </Paper>
  );
};

export default OfferSummarySection;
